import { render } from "./ImageShow.vue?vue&type=template&id=42da0a39"
import script from "./ImageShow.vue?vue&type=script&lang=js"
export * from "./ImageShow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__